import { Tabs } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import Data360LivePassViewAgGrid from "./pass_view";
import Data360LiveTiltViewAgGrid from "./tilt_view";
import Data360LiveZoneViewAgGrid from "./zone_view";

const D360LiveViewsTab = ({ setActiveTab, weld_number }) => {
  const currentProject = useSelector(
    (state) => state?.data360LiveProjectReducer?.currentProject
  );

  const tabKeys = {
    PassView: "PassView",
    ZoneView: "ZoneView",
    TiltView: "TiltView",
  };

  const tabItems = [
    {
      key: tabKeys.PassView,
      label: "Pass View",
      children: (
        <Data360LivePassViewAgGrid
          projectId={currentProject?.project_id}
          projectName={currentProject?.project_name}
          weldNumber={weld_number}
          statusCalculationMethod={currentProject?.statusCalculationMethod}
          currentProject={currentProject}
        />
      ),
    },
    {
      key: tabKeys.ZoneView,
      label: "Zone View",
      children: (
        <Data360LiveZoneViewAgGrid
          projectId={currentProject?.project_id}
          projectName={currentProject?.project_name}
          weldNumber={weld_number}
          statusCalculationMethod={currentProject?.statusCalculationMethod}
          currentProject={currentProject}
        />
      ),
    },
    {
      key: tabKeys.TiltView,
      label: "Tilt View",
      children: (
        <Data360LiveTiltViewAgGrid
          projectId={currentProject?.project_id}
          projectName={currentProject?.project_name}
          weldNumber={weld_number}
          statusCalculationMethod={currentProject?.statusCalculationMethod}
          currentProject={currentProject}
        />
      ),
    },
  ];

  const handleTabChange = (key) => {
    if (key === tabKeys.PassView) {
      setActiveTab("1");
    } else if (key === tabKeys.ZoneView) {
      setActiveTab("2");
    } else if (key === tabKeys.TiltView) {
      setActiveTab("3");
    }
  };

  return (
    <Tabs
      defaultActiveKey={tabKeys.PassView}
      items={tabItems}
      className="custom-tab"
      destroyInactiveTabPane={true}
      onChange={handleTabChange}
    />
  );
};

export default D360LiveViewsTab;
